<template>
  <div class="go-bind-wrapper">
    <!--未绑定时显示的页面-->
    <div class="no-bind-content" v-if="!hasBind">
      <div class="pic-content"><img src="../../assets/images/ol@2x.png"/></div>
      <p class="title">您还未绑定个人资料！</p>
      <p class="tips">绑定后，您可以进行预约挂号，查看随访记录； 还可以收到公众号推送患教和通知。</p>
      <div class="btn-style1">
        <p class="btn" @click="toBindInfo">去绑定</p>
      </div>
    </div>

    <!--已经绑定状态的显示的页面-->
    <div class="improve-info-wrapper" v-if="hasBind">
        <div class="basic-content">
          <p class="title">基本信息</p>
          <div class="item-basic">
            <span class="label">头像</span>
            <span class="right-info"><img class="user-pic" :src="headImgUrl"/></span>
          </div>
          <div class="item-basic">
            <span class="label">姓名</span>
            <span class="right-info">{{nickName}}</span>
          </div>
          <div class="item-basic">
            <span class="label">手机号</span>
            <span class="right-info">{{mobilePhone}}</span>
          </div>
        </div>
        <div class="divider-7pt"></div>
        <div class="basic-content">
          <p class="title">其他信息</p>
          <div class="item-basic">
            <span class="label">身份证号</span>
            <span class="right-info-select"><input class="inp margin-r" type="text" maxlength="18" v-model="idNo" placeholder="请输入"/></span>
          </div>
          <div class="item-basic"  @click="showSexPicker = true">
            <span class="label">性别</span>
            <span class="right-info-select"><span class="show-area">{{sex}}</span><img class="arrow-icon" src="../../assets/images/ou@2x.png"/></span>
          </div>
          <div class="item-basic">
            <span class="label">年龄</span>
            <span class="right-info-select"><input class="inp margin-r" type="tel" maxlength="2" v-model="age" placeholder="请输入" @change="ageVerify"/></span>
          </div>
          <div class="item-basic" @click="areaSelectHandler">
            <span class="label">所在地区</span>
            <span class="right-info-select">
            <span class="show-area spe-area">{{Province ? Province : ''}} {{City ? City : ''}} {{District ? District : ''}} {{Town ? Town : ''}}</span>
            <img class="arrow-icon" src="../../assets/images/ou@2x.png"/>
          </span>
          </div>
          <div class="item-special">
            <span class="label">详细地址</span>
            <!--<span class="right-info-select"><input class="inp margin-r" type="text"  maxlength="50" v-model="address" placeholder="请输入" @change="addressVerify"/></span>-->
            <div class="address-info">
              <textarea v-model="address" placeholder="请输入地址" maxlength="50" @change="addressVerify"></textarea>
            </div>
          </div>
        </div>
        <!--性别选择-->
        <div class="modal-sex-picker" v-show="showSexPicker">
          <ul class="sex-picker">
            <li @click="selectedSex(1)">男</li>
            <li @click="selectedSex(2)">女</li>
            <li @click="showSexPicker = false">取消</li>
          </ul>
        </div>

      </div>
    <!--省市区乡四级联动-->
    <div class="province-picker" v-show="showChose">
      <section class="showChose" @touchmove.prevent>
      </section>
      <section class="address">
        <section class="title1" @touchmove.prevent>
          <span class="address-name">居住地址</span>
          <span class="close-btn" @click="closeAdd()">×</span>
        </section>
        <section class="title2" @touchmove.prevent>
          <!--<div class="area" @click="provinceSelected()">{{Province?Province:info[province-1].name}}</div>-->
          <div class="area" @click="provinceSelected()" :class="Province?'':'active'">{{Province?Province:'请选择'}}</div>
          <div class="area" @click="citySelected()" :class="City?'':'active'" v-show="Province">{{City?City:'请选择'}}</div>
          <div class="area" @click="districtSelected()" :class="District?'':'active'" v-show="City">{{District?District:'请选择'}}</div>
          <div class="area" @click="townSelected()" :class="Town?'':'active'" v-show="District">{{Town?Town:'请选择'}}</div>
        </section>
        <ul @touchmove.stop ref="listShow">
          <li class="add-list" v-for="(v,k) in info" @click="getProvinceId(v.provinceId, v.provinceName, k)" v-show="showProvince" :class="v.selected ? 'active' : ''">{{v.provinceName}}</li>
          <li class="add-list" v-for="(v,k) in showCityList" @click="getCityId(v.cityId, v.cityName, k)" v-show="showCity" :class="v.selected ? 'active' : ''">{{v.cityName}}</li>
          <li class="add-list" v-for="(v,k) in showDistrictList" @click="getDistrictId(v.countyId, v.countyName, k)" v-show="showDistrict" :class="v.selected ? 'active' : ''">{{v.countyName}}</li>
          <li class="add-list" v-for="(v,k) in showTownList" @click="getTownId(v.townId, v.townName, k)" v-show="showTown" :class="v.selected ? 'active' : ''">{{v.townName}}</li>
        </ul>
      </section>
    </div>
      <!--<div class="fixed-btn" :class="hasChange ? '' : 'disabled'" @click="saveInfo">保存</div>-->
    <BtnFixed v-if="hasBind" @click.native="saveInfo" :isDisabled="hasChange" >保存</BtnFixed>
  </div>
</template>

<script>
  import util from "../../common/utils"
  import { userInfo } from '@/apis'
  import { mapState } from 'vuex'
  import wx from 'weixin-js-sdk'
  import { Toast,Indicator } from 'mint-ui';
  import BtnFixed from '@/components/BtnFixed'

  export default {
    data(){
      return {
        hasBind: 'no',
        hasChange: false,
        patientObj: {},
        patientId: '',
        headImgUrl: '',
        nickName: '',
        mobilePhone: '',
        idNo: '',
        sexNo: '',
        sex: '',
        age: '',
        address: '',
        showChose: false, //四级联动
        showProvince: true,
        showCity: false,
        showTown: false,
        showDistrict: false,
        showCityList: false,
        showDistrictList: false,
        showTownList: false,
        provinceId: '',
        // provinceId: 110,
        cityId: '',
        // cityId: 110100000000,
        districtId: '',
        // districtId: 110105000000,
        townId: '',
        // townId: 110105001000,
        District: false,
        Province: false,
        City: false,
        Town: false,
        // v-for循环判断是否为当前
        selected: false,
        info: [],
        uuid: '',
        showSexPicker: false
      }
    },
    components:{BtnFixed},
    computed: {
      controlBtnClass(){
      },
      ...mapState({
        openid: state => state.openid,
      })
    },
    watch: {
      sex(val, oldVal){
        if(val == null){
          this.hasChange = false;
        }else {
          this.hasChange = true;
        }
      },
      Province(val1, oldVal1){
        this.hasChange = true;
      },
      idNo(val2, oldVal2){
        this.hasChange = true;
      },
      age(val3, oldVal3){
        if(val3 == null){
          this.hasChange = false;
        }else {
          this.hasChange = true;
        }
      },
      address(val4, oldVal4){
        this.hasChange = true;
      }
    },
    created(){
      this.initInfo();
      //安卓调起软键盘时遮挡输入框的问题
      if(/Android [4-6]/.test(navigator.appVersion)) {
        window.addEventListener("resize", function() {
          if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
            window.setTimeout(function() {
              document.activeElement.scrollIntoViewIfNeeded();
            },0);
          }
        })
      }
    },
    mounted(){
      /*this.$refs.listShow.addEventListener('scroll', (e) => {
        // console.log(" scroll " + this.$refs.listShow.scrollTop)
        // this.isScroll=this.$refs.viewBox.scrollTop>0
        if(this.$refs.listShow.scrollTop >= this.$refs.listShow.scrollHeight-this.$refs.listShow.offsetHeight){
          e.preventDefault();
        }
      }, false);*/
    },
    methods: {
      initInfo(){
        this.axios.get(userInfo.queryPatientsInfo,{
          params: {
            openId: this.openid,
            // openId: 'o0wDk01IOru4dCuPnRko8Y8JznGk'
          }
        }).then((data) => {
          let res =data.data;
          if(res.code === '000000'){
            this.hasBind = res.data.hasBinded;
            if(this.hasBind === true){
              this.patientObj = res.data.patientDto;
              this.headImgUrl = res.data.patientDto.headImgUrl;
              this.nickName = res.data.patientDto.nickName;
              this.patientId = res.data.patientDto.id;
              this.mobilePhone = res.data.patientDto.mobilePhone;
              this.idNo = res.data.patientDto.idNo;
              this.sexNo = res.data.patientDto.sex;
              this.age = res.data.patientDto.age;
              this.address = res.data.patientDto.address;
              this.provinceId = res.data.patientDto.province;
              this.cityId = res.data.patientDto.city;
              this.districtId = res.data.patientDto.county;
              this.townId = res.data.patientDto.town;
              this.uuid = res.data.patientDto.uuid
              if(this.sexNo === 1){
                this.sex = '男'
              }else if(this.sexNo === 2){
                this.sex = '女'
              }else {
                this.sex = ''
              }
              if(!this.idNo && !this.sex && !this.age && !this.address && !this.provinceId){
                this.hasChange = false;
              }else {
                this.hasChange = true;
              }
              //  初始化省市区
              if(this.provinceId){
                this.getProvinceList();
              }
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      //未绑定时去绑定的事件
      toBindInfo(){
        this.$router.push({
          path: '/editUserInfo'
        })
      },
      //身份证输入失焦操作
      /*idCardVerify(){
        if(this.idNo != '' && !util.verifyIDCard(this.idNo)){
          // Toast('身份证格式错误');
          return;
        }
        if(this.idNo != ''){
          this.hasChange = true;
        }
      },*/
      //验证年龄输入
      ageVerify(){
        if(!util.verifyPureNum(this.age)){
          Toast('请输入正确的年龄格式');
        }
        this.hasChange = true;
      },
      //地址输入
      addressVerify(){
        this.hasChange = true;
      },
      //性别选择操作
      selectedSex(val){
        if(val === 1){
          this.sex = '男';
          this.sexNo = '1';
        }else if(val === 2){
          this.sex = '女';
          this.sexNo = '2';
        }
        this.showSexPicker = false;
      },
      //选择
      areaSelectHandler(){
        this.showChose = true;
        this.getProvinceList();
        document.getElementsByTagName("body")[0].className="overflow-hidden";
      },
      //省市区乡选择操作
      closeAdd(){
        this.showChose = false;
        if(!this.Province){
          this.provinceId = '';
        }
        if(!this.City){
          this.cityId = '';
        }
        if(!this.District){
          this.districtId = '';
        }
        if(!this.Town){
          this.townId = '';
        }
        document.getElementsByTagName("body")[0].className="";
      },
      // 获取省份列表
      getProvinceList(){
        let _self = this;
        _self.axios.get(userInfo.queryProvinceList,{}).then((data) => {
          let res =data.data;
          if(res.code === '000000'){
            _self.info = res.data.provinceList;
            //初始化省份的展示
            if(_self.provinceId != null || _self.provinceId != '' || _self.provinceId != undefined){
              for(let i = 0; i < this.info.length; i++){
                if(_self.provinceId === _self.info[i].provinceId){
                  _self.Province = _self.info[i].provinceName;
                }
              }
            }
            if(_self.cityId){
              _self.getCityList(_self.provinceId);
            }
            if(_self.districtId){
              _self.getDistrictList(_self.cityId);
            }
            if(_self.townId){
              _self.getTownList(_self.districtId);
            }
            /*if(this.provinceId != null || this.provinceId != '' || this.provinceId != undefined){
              this.getCityList(this.provinceId);
              if(this.cityId != null || this.cityId != '' || this.cityId != undefined){
                this.getDistrictList(this.cityId);
                if(this.districtId != null || this.districtId != '' || this.districtId != undefined){
                  this.getTownList(this.districtId);
                }else {
                  return
                }
              }else {
                return
              }
            }else {
              return;
            }*/
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      // 获取市列表
      getCityList(provinceIdPara){
        this.axios.get(userInfo.queryCityList,{
          params:{
            provinceId: provinceIdPara
          }
        }).then((data) => {
          let res =data.data;
          if(res.code === '000000'){
            this.showCityList = res.data.cityList;
            //初始化市的展示
            if(this.cityId != null || this.cityId != '' || this.cityId != undefined){
              for(let i = 0; i < this.showCityList.length; i++){
                if(this.cityId == this.showCityList[i].cityId){
                  this.City = this.showCityList[i].cityName;
                }
              }
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      // 获取县或者区列表
      getDistrictList(cityIdPara){
        this.axios.get(userInfo.queryDistrictList,{
          params:{
            cityId: cityIdPara
          }
        }).then((data) => {
          let res =data.data;
          if(res.code === '000000'){
            this.showDistrictList = res.data.countyList;
            //初始化县或区的展示
            if(this.districtId != null || this.districtId != '' || this.districtId != undefined){
              for(let i = 0; i < this.showDistrictList.length; i++){
                if(this.districtId == this.showDistrictList[i].countyId){
                  this.District = this.showDistrictList[i].countyName;
                }
              }
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      // 获取乡镇列表
      getTownList(districtIdPara){
        this.axios.get(userInfo.queryTownList,{
          params:{
            countyId: districtIdPara
          }
        }).then((data) => {
          let res =data.data;
          if(res.code === '000000'){
            this.showTownList = res.data.townList;
            //初始化乡镇的展示
            if(this.townId != null || this.townId != '' || this.townId != undefined){
              for(let i = 0; i < this.showTownList.length; i++){
                if(this.townId == this.showTownList[i].townId){
                  this.Town = this.showTownList[i].townName;
                }
              }
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      getProvinceId(code,input,index){
        this.provinceId = code;
        this.Province = input;

        this.showProvince=false;
        this.showCity=true;
        this.showDistrict = false;
        this.showTown = false;

        this.City = false;
        this.District = false;
        this.Town = false;
        // this.showCityList = this._filter(this.info,'city',this.province);
        this.getCityList(this.provinceId);
        // 点击选择当前
        this.info.map( a => a.selected = false );
        this.info[index].selected = true;
      },
      provinceSelected(){
        // 清除市级区级及乡级列表
        this.showCityList = false;
        this.showDistrictList = false;
        this.showTown = false;
        // 清除市级和区级及乡级选项
        this.City = false;
        this.District = false;
        this.Town = false;
        // 选项页面的切换
        this.showProvince = true;
        this.showCity = false;
        this.showDistrict = false;
        this.Town = false;
      },
      getCityId(code, input, index){
        this.cityId = code;
        this.City = input;
        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = true;
        this.showTown = false;
        // this.showDistrictList = this._filter(this.showCityList,'district',this.city);
        this.getDistrictList(this.cityId);
        // 选择当前添加active
        this.showCityList.map( a => a.selected = false );
        this.showCityList[index].selected = true;
      },
      citySelected(){
        // 清除区级及乡级列表
        this.showDistrictList = false;
        this.showTown = false;
        // 清除区级及乡级选项
        this.District = false;
        this.Town = false;

        this.showProvince=false;
        this.showCity=true;
        this.showDistrict = false;
        this.showTown = false;
      },
      getDistrictId(code, input, index){
        this.districtId = code;
        this.District = input;
        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = false;
        this.showTown = true;
        // this.showTownList = this._filter(this.showDistrictList,'town',this.district);
        this.getTownList(this.districtId);
        // 选择当前添加active
        this.showDistrictList.map( a => a.selected = false );
        this.showDistrictList[index].selected = true;
        // 选取市区选项之后关闭弹层
        // this.showChose = false;
      },
      districtSelected(){
        // 清除乡级列表
        this.showTown = false;
        // 清除乡级选项
        this.Town = false;

        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = true;
        this.showTown = false;
      },
      getTownId(code, input, index){
        this.townId = code;
        this.Town = input;

        // 选择当前添加active
        this.showTownList.map( a => a.selected = false );
        this.showTownList[index].selected = true;
        // 选取乡镇选项之后关闭弹层
        this.showChose = false;
      },
      townSelected(){
        this.showProvince=false;
        this.showCity=false;
        this.showDistrict = false;
        this.showTown = true;
      },
      //点击保存操作
      saveInfo(){
        if ((this.idNo == '' || this.idNo == null || (this.idNo != '' && util.verifyIDCard(this.idNo))) && (this.age == '' || this.age == null || (this.age != '' && util.verifyPureNum(this.age)))){
          if(this.hasChange === true){
            this.axios.post(userInfo.bindPatientsInfo,{
              id: this.patientId,
              headImgUrl: this.headImgUrl,
              idNo: this.idNo,
              sex: this.sexNo,
              age: this.age,
              province: this.provinceId,
              city: this.cityId,
              county: this.districtId,
              town: this.townId,
              address: this.address,
              uuid: this.uuid
            }).then((data) => {
              let res = data.data;
              console.log(res);
              if(res.code === '000000'){
                Toast('保存成功');
                setTimeout(() => {
                  // window.history.back();
                  wx.closeWindow();
                }, 1000);
              }else {
                Toast(res.message);
              }
            }).catch(function (error) {
              console.log(error);
            });
          }
        }else {
          if(!util.verifyIDCard(this.idNo.trim())){
            Toast('请输入正确的身份证号');
          }else if(!util.verifyPureNum(this.age.trim())){
            Toast('请输入正确的年龄');
          }
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  /*[v-cloak] { display: none }*/
  .overflow-hidden{
    overflow: hidden !important;
  }
  .go-bind-wrapper{
    /*background-color: #ffffff;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*min-height: 100vh;*/
    /*padding-bottom: 45px;*/
    /*overflow: hidden;*/
    position: relative;
//    @include background();
    width: 100%;
    height: 100%;
    background:$bgfff;
    .no-bind-content{
      .pic-content{
        width: 100%;
        text-align: center;
        padding-top: 66px;
        @include flex;
        @include justify-content(center);
        img{
          width: 80px;
          height: 80px;
        }
      }
      .title{
        text-align: center;
        color: #333333;
        font-size: 16px;
        margin-top: 10px;
      }
      .tips{
        width: 100%;
        box-sizing: border-box;
        padding: 0 40px;
        font-size: 14px;
        color: #999999;
        text-align: center;
        margin-top: 15px;
        line-height: 18px;
      }
      .btn-style1{
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        height: 45px;
        margin-top: 30px;
        .btn{
          width: 100%;
          height: 45px;
          line-height: 45px;
          text-align: center;
          border-radius: 23px;
          font-size: 16px;
          background-color: #41B7A7;
          color: #ffffff;
          letter-spacing: 1px;
        }
      }
    }
    .improve-info-wrapper{
      width: 100%;
      /*height: 100%;*/
      padding-bottom: 46px;
      ::-webkit-input-placeholder { /* WebKit browsers */
        color: #999;
      }
      :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #999;
      }
      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #999;
      }
      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #999;
      }
      .basic-content{
        .title{
          @include flex;
          @include align-items;
          height: 46px;
          color: #41B7A7;
          font-size: 15px;
          padding-left: 15px;
          &:before{
            content: '';
            position: absolute;
            left: 0;
            width: 4px;
            height: 20px;
            background-color: #41B7A7;
            border-radius: 0 1px 1px 0;
          }
        }
      }
      .item-basic{
        @include flex;
        @include align-items;
        @include justify-content(space-between);
        height: 46px;
        border-top: 1PX solid #EEEEEE;
        box-sizing: border-box;
        padding-left: 15px;
        .label{
          color: #666666;
          font-size: 15px;
          min-width: 85px;
          @include flex-value(1);
        }
        .right-info{
          color: #999999;
          font-size: 15px;
          margin-right: 37px;
          .user-pic{
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        }
        .right-info-select{
          color: #999999;
          font-size: 15px;
          margin-right: 10px;
          display: inline-block;
          @include flex;
          @include align-items;
          .show-area{
            color: #666666;
            display: inline-block;
            max-width: 240px;
            /*line-height: 18px;*/
            &.spe-area{
              width: 240px;
              text-align: right;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
          .inp{
            box-sizing: border-box;
            min-width: 240px;
            text-align: right;
            color: #666666;
            line-height: 25px;
            height: 44px;
            padding-right: 5px;
            /*overflow: hidden;*/
            /*text-overflow:ellipsis;*/
            &.margin-r{
              margin-right: 22px;
            }
          }
          .arrow-icon{
            width: 25px;
            height: 25px;
            margin-left: 2px;
          }
        }
        &.border-b{
          border-bottom: 1PX solid #EEEEEE;
        }
      }
      .item-special{
        @include flex;
        border-top: 1PX solid #EEEEEE;
        border-bottom: 1PX solid #EEEEEE;
        box-sizing: border-box;
        padding-left: 15px;
        .label{
          color: #666666;
          font-size: 15px;
          width: 85px;
          height: 45px;
          line-height: 45px;
        }
        .address-info{
          font-size: 15px;
          width: 260px;
          padding: 10px 0;
          textarea{
            font-family: 'PingFangSC';
            width: 100%;
            line-height: 25px;
            min-height: 75px;
            font-size: 15px;
            color: #666666;
            border: none;
            outline: none;
          }
        }
      }
      .divider-7pt{
        width: 100%;
        height: 7px;
        background-color: #F8F8F8;
      }
      .popup-content{
        width: 375px;
      }
      /*.fixed-btn{
        width: 100%;
        height: 45px;
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 45px;
        text-align: center;
        background-color: #41B7A7;
        z-index: 100;
        &.disabled{
          background-color: #CCCCCC;
        }
      }*/
      /*性别选择样式*/
      .modal-sex-picker{
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        z-index: 2000;
        .sex-picker{
          position: absolute;
          bottom: 0px;
          left: 0;
          width: 100%;
          padding: 5px 8px;
          li{
            width: 100%;
            height: 45px;
            line-height: 45px;
            text-align: center;
            background-color: #ffffff;
            font-size: 15px;
            color: #41B7A7;
            &:nth-of-type(1){
              border-radius: 8px 8px 0 0;
            }
            &:nth-of-type(2){
              border-radius: 0 0 8px 8px;
              border-top: 1PX solid #EEEEEE;
            }
            &:last-of-type{
              margin-top:8px;
              border-radius: 8px;
            }
          }
        }
      }
    }
    /*四级联动样式*/
    .province-picker{
      width: 100%;
      .showChose{
        width:100%;
        height:100%;
        position:fixed;
        top:0;
        left:0;
        bottom:0;
        z-index:120;
        background:rgba(0,0,0,0.6);
      }
      .address{
        position:fixed;
        bottom:0;
        left:0;
        z-index:125;
        background:#fff;
        width:100%;
        .title1{
          border-bottom: 1PX solid #EEEEEE;
          .address-name{
            display:inline-block;
            text-align: center;
            margin-left: 150px;
            font-size: 16px;
            line-height: 42px;
            color:#999;
          }
          .close-btn{
            margin: 0 0 0 100px;
            font-size: 22px;
            line-height: 40px;
            padding: 2px 20px;
            color:#D8D8D8;
          }
        }
        .title2{
          /*border-bottom: 1PX solid #EEEEEE;*/
          @include flex;
          .area{
            display:inline-block;
            font-size: 15px;
            line-height: 35px;
            height: 35px;
            /*margin-left: 15px;*/
            box-sizing: border-box;
            width: 25%;
            text-align: center;
            padding: 0 3px;
            color:#333;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            &.active{
              color:#41B7A7;
              border-bottom:2px solid #41B7A7;
            }
          }
        }
        ul{
          box-sizing: border-box;
          /*width:95%;*/
          width: 100%;
          height:100%;
          max-height: 350px;
          overflow:auto;
          -webkit-overflow-scrolling: touch;
          li.add-list{
            box-sizing: border-box;
            width:100%;
            height: 35px;
            display: block;
            font-size: 15px;
            line-height: 35px;
            color:#333;
            padding-left: 5%;
            &.active{
              color:#41B7A7;
            }
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/goBind/goBind.vue